// ----------------------------------------------------------------------

/**
 * What a viewer sees before touching the settings drawer, and the baseline `canReset` and the reset
 * button compare against. It lives here, and not next to the provider's only caller, because the
 * loader that `utils/axios` renders outside the app tree mounts its own provider and needs the same
 * values; a second copy of this object would let the two drift apart.
 */
export const DEFAULT_SETTINGS = {
  themeMode: "light", // 'light' | 'dark'
  themeDirection: "ltr", //  'rtl' | 'ltr'
  themeContrast: "default", // 'default' | 'bold'
  themeLayout: "vertical", // 'vertical' | 'horizontal' | 'mini'
  themeColorPresets: "default", // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
  themeStretch: true,
};
